import { z } from "zod";
import { VariableSchema } from "./Variable";
import { CategorySchema } from "./Category";

export const VariableResponseSchema = VariableSchema.extend({
  categories: z.array(CategorySchema),
});

export type VariableResponse = z.infer<typeof VariableResponseSchema>;